var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.textoDestacado),function(texto,index){return _c('span',{key:`versiculo-${index}`,class:{ destaque: texto.destaque }},[_vm._v(_vm._s(texto.texto))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }